import * as React from 'react';
import { generatePath, Link } from 'react-router-dom';

import Card from 'antd/lib/card';
import { Col, Row } from 'antd/lib/grid';

import { BatchAction } from '@app/objects/BatchAction';
import { DateView } from '@app/components/UI/Views/DateView/DateView';
import { PictureWall } from '@app/components/Forms/PictureWall';
import { RoutePaths } from '@app/utilities/RoutePathVars';

interface BatchActionProps {
	batchAction: BatchAction | null;
	position: string;

	className?: string;
	style?: React.CSSProperties;
}

const getValidDate = (date: number | undefined | null) => {
	if (!date || date <= 0) return '—';

	return (
		<DateView date={date} withTime />
	);
};

const getLink = (batchId: number | undefined | null) => {
	if (batchId && batchId > 0) {
		const path = generatePath(RoutePaths.batchEditor, { id: batchId });

		return (
			<Link to={path}>
				#{batchId}
			</Link>
		);
	}

	return '—';
};

export const BatchComponent: React.FC<BatchActionProps> = ({
	batchAction,
	position,
	className,
	style,
}) => {
	if (!batchAction) return null;

	return (
		<div className={className} style={style}>
			<Card title={<strong className="field-heading">Batch</strong>} size="small">
				<Row gutter={[30, 0]}>
					<Col xs={24} sm={24} md={8}>
						<strong>Batch number: </strong>
						{getLink(batchAction?.id)}
					</Col>
					<Col xs={24} sm={24} md={8}>
						<strong>Machine: </strong>
						{batchAction?.machine?.name ?? '—'}
					</Col>
					<Col xs={24} sm={24} md={8}>
						<strong>Position: </strong>
						{position?.length ? position : '—'}
					</Col>
				</Row>
				<Row gutter={[30, 0]}>
					<Col xs={24} sm={24} md={8}>
						<strong>Created date: </strong>
						{getValidDate(batchAction?.createdDate)}
					</Col>
					<Col xs={24} sm={24} md={8}>
						<strong>Finished date: </strong>
						{getValidDate(batchAction?.finishedDate)}
					</Col>
				</Row>
				<Row gutter={[30, 0]}>
					{batchAction.files.length > 0 && (
						<Col xs={24} sm={24}>
							<div className="card__content--wall">
								<PictureWall
									id={batchAction.id}
									type="batchAction"
									object={batchAction.files}
									buttonCaption="Upload"
									infoMessage="Image size must not exceed 4 Mb"
									style={{ height: 100, width: 100 }}
									lineHeight={100}

									withDeleteBtn={false}
								/>
							</div>
						</Col>
					)}
				</Row>
			</Card>
		</div>
	);
};
